module.exports = __webpack_public_path__ + "static/AllMediaDesk_Logo_light_background_RGB-42cb59729ac8a6882036c816e7523e83.svg";